<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="fm1"> </p>
<p class="FMH1"><span href="#/xhtml/contents#c_fm1" title="Link target outside of Sample"><span class="ePub-B">THE MISTRAL</span></span></p>
<p class="FM-Head-fmh1"><span href="#/xhtml/contents#c_fm1" title="Link target outside of Sample"><span class="ePub-I">of the Air Signal Corps</span></span></p>
<p class="IMG"><img alt="image" height="300" src="images/pg8.jpg" width="825"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmart1.vue?67fffc9c